import React from 'react';

import { DefaultContext } from '@apollo/client';

import { Nullable } from '@clearverify/types';

import {
  useVerifierBillingRulesQuery,
  useVerifierBillingRulesUpdateMutation,
  VerifierBillingRulesDocument,
} from 'src/api';
import { VerifierBillingSettingsMutationDataType } from 'src/types/billing';

export const useVerifierBillingRules = (id: Nullable<string>) => {
  const { data, loading } = useVerifierBillingRulesQuery({
    variables: {
      id: String(id),
    },
  });

  const verifierBilling = React.useMemo(() => data?.verifier, [data?.verifier]);

  const [verifierBillingRulesUpdateMutation, { loading: updating }] =
    useVerifierBillingRulesUpdateMutation({
      refetchQueries: [VerifierBillingRulesDocument],
    });

  const updateVerifierBillingRules = async (params: {
    data: VerifierBillingSettingsMutationDataType;
    context: DefaultContext;
  }) => {
    const { data, context } = params;
    if (!id) return;

    await verifierBillingRulesUpdateMutation({
      variables: { id, data },
      context,
    });
  };

  return {
    verifierBilling,
    updateVerifierBillingRules,
    loading: loading || updating,
  };
};
